import * as React from 'react';
import { SlideDown } from '@digital/react-aviva-atom';

interface Props {
    expanded?: boolean;
    className?: string;
}

export class ImportantInformation extends React.PureComponent<Props> {
    static defaultProps: Partial<Props> = {
        expanded: false
    };
    
    render() {
        return (
            <SlideDown header="Important Information" expanded={this.props.expanded}>
                <ul>
                    <li> 
                        The policyholder must activate the insurance by contacting Aviva Direct or 
                        their Aviva broker within 7 days of their first driving lesson, the pupil is then 
                        entitled to 6 months Free Accompanied Driver Cover on an existing Aviva private car insurance 
                        policy.
                    </li>
                    <li>
                        The pupil will need to complete their first lesson with their Aviva driving instructor 
                        before they can be insured on the policyholder's Aviva car insurance policy. 
                        Their driving instructor will give the pupil a pin number which the policyholder
                        will then use to activate the Free Accompanied Driver Cover.
                    </li>
                    <li>
                        All products must be used within twelve months of the date of purchase. 
                        However, where you have availed of the Free Accompanied Driver Cover, all 
                        driving lessons must be taken within the 6 months Free Accompanied Driver Cover period.
                    </li>
                    <li>
                        The pupil availing of the 6 months Free Accompanied Driver Cover must be accompanied at all 
                        times by the policyholder or a named driver on the policy who holds a full EU licence for a 
                        continuous period of two years in respect of the 
                        vehicle category (subject to the terms and conditions).
                    </li>
                    <li>
                        Breaks in the Free Accompanied Driver Cover are not permitted.
                    </li>
                    <li>
                        The Free Accompanied Driver cover must be activated through your 
                        insurance provider; Aviva Direct or with your Aviva Broker   
                    </li>
                    <li>
                        Your second and subsequent driving lessons must be booked directly with your driving instructor.
                    </li>
                </ul>
            </SlideDown>
        );
    }
}